exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1l_CU{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._1l_CU:hover{opacity:.7}.bLiz7{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}.RFKoO{display:flex;flex:0 0 auto;height:25px;align-items:center}.BDkBU{font-size:12px;line-height:12px}[data-playable-hook='player-container'][data-playable-in-full-screen=\"true\"] .BDkBU{font-size:14px;line-height:14px}._1VXDz{margin-left:5px}._1VXDz:before{margin-right:4px;content:'/'}._2AYFL ._26VfS{display:none}._2AYFL ._1VXDz{display:none}\n", ""]);

// Exports
exports.locals = {
	"controlButton": "_1l_CU",
	"hidden": "bLiz7",
	"timeWrapper": "RFKoO",
	"time": "BDkBU",
	"duration": "_1VXDz",
	"liveMode": "_2AYFL",
	"separator": "_26VfS"
};